/// <amd-module name="Agile/Sprints/Directory/SprintDirectoryContracts" />
import { IDirectoryArtifact, IDirectoryDataProviderData, IArtifactOwner, IDirectoryViewState } from "Agile/Directory/DirectoryContracts";

export interface ISprintDirectoryViewState extends IDirectoryViewState<ISprintDirectoryArtifact>, ISprintDirectoryAwareState {}

export interface ISprintDirectoryAwareState {
    sprintDirectoryState: ISprintDirectoryState;
}

export interface ISprintDirectoryState {
    isSprintPaneOpen: boolean;
    allTeams?: IArtifactOwner[];
    pageSize?: number;
    editSprintInformation?: {
        iterationId: string;
        team: { id: string; name: string };
    };
}

export interface ISprintDirectoryArtifact extends IDirectoryArtifact {
    iterationId: string;
    iterationName: string;
    iterationStartDate?: Date;
    iterationEndDate?: Date;
}

export interface ISprintsDirectoryDataProviderData extends IDirectoryDataProviderData<ISprintDirectoryArtifact> {
    allTeams: IArtifactOwner[];
    pageSize: number;
}
